import { gql } from '@apollo/client';

export const DELETE_COMMENT = gql`
  mutation deleteComment($id: Int!) {
    deleteComment(id: $id) {
      id
    }
  }
`;

export const CREATE_COMMENT = gql`
  mutation createComment($input: CommentInput!) {
    createComment(input: $input) {
      id
    }
  }
`;

export const UPDATE_COMMENT = gql`
  mutation UpdateComment($id: Int!, $input: CommentUpdateInput!) {
    updateComment(id: $id, input: $input) {
      id
    }
  }
`;

export const GET_COMMENTS = gql`
  query comments($input: CommentSearchInput!) {
    comments(input: $input) {
      data {
        id
        type
        text
        author {
          last_name
          first_name
        }
        created_at
        is_important
      }
    }
  }
`;
